import React from "react";
import { FiTarget } from "react-icons/fi";
import MiniGamePage from "./MiniGamePage";
import { slotsGameApi } from "../../utils/miniGameApi";

const SlotsGame = () => (
  <MiniGamePage
    title="Slot Machine"
    selfLabel="Slot Machine"
    description="Configure jackpot rewards, 3-reel point combinations, and inspect spin history."
    icon={FiTarget}
    api={slotsGameApi}
    scoreLabel="Spin Points"
    switchTo={[
      { to: "/tap-game", label: "Tap Game" },
      { to: "/boom-cards-game", label: "Boom Cards" },
      { to: "/game-2048", label: "2048" },
      { to: "/fruit-cut", label: "Fruit Cut" },
    ]}
  />
);

export default SlotsGame;
